import { AssignRebarEstimationsRequest } from "@api/apiClient";
import { useAssignRebarEstimations as useAssignRebarEstimationsMutation } from "@api/models";
import useSelectionManager from "@hooks/useSelectionManager";
import { useCallback } from "react";

interface UseAssignRebarEstimationsParams {
  /** Callback invoked after successful rebar estimation assignment (e.g., to refetch data) */
  onSuccess?: () => void | Promise<void>;
}

interface UseAssignRebarEstimationsResult {
  handleAssignRebarEstimations: () => Promise<void>;
  isAssignRebarEstimationsPending: boolean;
}

export const useAssignRebarEstimations = ({
  onSuccess,
}: UseAssignRebarEstimationsParams = {}): UseAssignRebarEstimationsResult => {
  const selectionManager = useSelectionManager();
  const projectId = selectionManager.selectedProject?.projectId;
  const mutateAssignRebarEstimations = useAssignRebarEstimationsMutation();

  const handleAssignRebarEstimations = useCallback(async () => {
    const assignRebarEstimationsRequest = new AssignRebarEstimationsRequest({
      projectId,
      modelIds: selectionManager.getSelectedModelIds(),
      scenarioId: selectionManager.selectedScenarioId
    });
    await mutateAssignRebarEstimations.mutateAsync(assignRebarEstimationsRequest as any);
    await onSuccess?.();
  }, [mutateAssignRebarEstimations, onSuccess, projectId, selectionManager]);

  return {
    handleAssignRebarEstimations,
    isAssignRebarEstimationsPending: mutateAssignRebarEstimations.isPending,
  };
};
